export default __webpack_public_path__ + "static/media/sounds/rct_opening.mp3";